module.exports = __webpack_public_path__ + "img/rt_pukwan01.3b93efb3.jpg";